import { render, staticRenderFns } from "./TruckScaleTimeline.vue?vue&type=template&id=2ec13a2c&scoped=true&"
import script from "./TruckScaleTimeline.vue?vue&type=script&lang=js&"
export * from "./TruckScaleTimeline.vue?vue&type=script&lang=js&"
import style0 from "./TruckScaleTimeline.vue?vue&type=style&index=0&id=2ec13a2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec13a2c",
  null
  
)

export default component.exports